import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-actions-bar',
    templateUrl: './actions-bar.component.html',
    styleUrls: ['./actions-bar.component.scss'],
    standalone: false
})
export class ActionsBarComponent {
  @Input() moduleID: any;
  @Input() referenceID: any;
  @Input() watchUserDetail: any;
  // Email launcher context — each module's detail page supplies these so the sent
  // email links back to the record and the subject is pre-filled.
  @Input() moduleName = '';
  @Input() recordName = '';
  @Input() emailSubject = '';
  
  @Output() onPrint = new EventEmitter<void>();
  @Output() onExport = new EventEmitter<void>();
  @Output() onShare = new EventEmitter<void>();
  @Output() onEmail = new EventEmitter<void>();
  @Output() onWatchOptionSelected = new EventEmitter<any>();

  /**
   * Handle print action - triggers browser print
   */
  handlePrint(): void {
    window.print();
    this.onPrint.emit();
  }

  /**
   * Handle export action - emits to parent for PDF generation
   */
  handleExport(): void {
    this.onExport.emit();
  }

  /**
   * Handle share action - placeholder for now
   */
  handleShare(): void {
    // Placeholder - can be implemented later
    console.log('Share functionality to be implemented');
    this.onShare.emit();
  }

  /**
   * Handle email action - placeholder for now
   */
  handleEmail(): void {
    // Placeholder - can be implemented later
    console.log('Email functionality to be implemented');
    this.onEmail.emit();
  }
}